export const GET_APPOINTMENT_LIST = 'GET_APPOINTMENT_LIST';

export const GET_APPOINTMENT_LIST_SUCCESS = 'GET_APPOINTMENT_LIST_SUCCESS';

export const GET_APPOINTMENT_LIST_FAILED = 'GET_APPOINTMENT_LIST_FAILED';